import type { HottieContextPermission } from '../types';

export const DEFAULT_HOTTIE_PERMISSION: HottieContextPermission = {
  enabled: false,
  shareFocusAreas: false,
  shareActiveBreakout: false,
  shareGoals: false,
  shareMomentum: false,
  shareTriggers: false,
  shareNudgePrefs: false,
  updatedAt: null,
};

/** Enabling Hottie requires an explicit opt-in; sub-flags default off until toggled. */
export const enableHottieSharing = (
  current: HottieContextPermission,
  now = new Date(),
): HottieContextPermission => ({
  ...current,
  enabled: true,
  updatedAt: now.toISOString(),
});

export const disableHottieSharing = (
  _current: HottieContextPermission,
  now = new Date(),
): HottieContextPermission => ({
  ...DEFAULT_HOTTIE_PERMISSION,
  updatedAt: now.toISOString(),
});

export const setHottieFlag = (
  current: HottieContextPermission,
  flag: keyof Omit<HottieContextPermission, 'enabled' | 'updatedAt'>,
  value: boolean,
  now = new Date(),
): HottieContextPermission => {
  if (!current.enabled && value) {
    // Sub-flags cannot turn on without master enable.
    return current;
  }
  return {
    ...current,
    [flag]: value,
    updatedAt: now.toISOString(),
  };
};
